import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { Favorite } from './marketplace.models';
import { unwrapPage, Paginated } from './pagination.util';

@Injectable({ providedIn: 'root' })
export class FavoriteService {
  private apiUrl = serviceurl + 'api/v1/favorites';

  constructor(private http: HttpClient) {}

  list(): Observable<Favorite[]> {
    return this.http.get<Paginated<Favorite> | Favorite[]>(`${this.apiUrl}/`).pipe(unwrapPage<Favorite>());
  }

  add(listingId: number): Observable<Favorite> {
    return this.http.post<Favorite>(`${this.apiUrl}/`, { listing: listingId });
  }

  remove(favoriteId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${favoriteId}/`);
  }
}
